import React, { createRef } from 'react';
import BudgetHistoryCard from 'components_v2/common/BudgetHistoryCard/BudgetHistoryCard';
import s from './BudgetHistoryWrapper.scss';

class BudgetHistoryWrapper extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      active: 0,
    };
    this.timelineRefs =
      this.props.sectionData.items &&
      Array.isArray(this.props.sectionData.items) &&
      this.props.sectionData.items.length > 0
        ? this.props.sectionData.items.map(() => createRef())
        : [];
    this.containerRef = createRef();
  }
  render() {
    const { items = [] } = this.props.sectionData;
    return (
      <div className={s.budgetHistoryWrapper}>
        <meta name="format-detection" content="telephone=no" />
        <div className={`${s.timeLineWrap}`} ref={this.containerRef}>
          {items &&
            Array.isArray(items) &&
            items.length > 0 &&
            items.map((it, index) => (
              <div
                ref={
                  this.timelineRefs.length > index && this.timelineRefs[index]
                }
                className={`${s.timeLine} ${
                  this.state.active === index ? s.active : ''
                }`}
                onClick={() => {
                  this.setState({ active: index }, () => {
                    const element = this.timelineRefs[index].current;
                    const container = this.containerRef.current;
                    if (container && element) {
                      const containerRect = container.getBoundingClientRect();
                      const elementRect = element.getBoundingClientRect();
                      // Adjust the scroll position of the container
                      container.scrollLeft +=
                        elementRect.left -
                        containerRect.left -
                        (containerRect.width / 2 - elementRect.width / 2);
                      if (index === items.length - 1) {
                        setTimeout(() => {
                          container.scrollLeft +=
                            elementRect.left -
                            containerRect.left -
                            (containerRect.width / 2 - elementRect.width / 2);
                        }, 500);
                      }
                    }
                  });
                }}
              >
                <div className={s.yearTextWrap}>{it.name}</div>
                <div className={s.blueLine} />
              </div>
            ))}
        </div>
        <div className={`${s.cardWrap}`}>
          {items &&
            Array.isArray(items) &&
            items.length > this.state.active &&
            items[this.state.active].special_items &&
            Array.isArray(items[this.state.active].special_items) &&
            items[this.state.active].special_items.length > 0 &&
            items[this.state.active].special_items.map(it => (
              <BudgetHistoryCard data={it} isStandAlone />
            ))}
          {items &&
            Array.isArray(items) &&
            items.length > this.state.active &&
            items[this.state.active].items &&
            Array.isArray(items[this.state.active].items) &&
            items[this.state.active].items.length > 0 &&
            items[this.state.active].items.map(it => (
              <BudgetHistoryCard data={it} />
            ))}
        </div>
        <p className={s.otherBtmInfoText}>Knowledge Partner: EY</p>
      </div>
    );
  }
}

export default BudgetHistoryWrapper;
